const PaginationComponent = {
    template: require('./pagination.component.html'),
    bindToController: true,
    bindings: {
        result: '<',
        onPageChange: '&'
    },
    controller: function () {
        const vm = this;

        vm.$onChanges = function (changes) {
            if (changes.result) {
                vm.currentPage = vm.result && vm.result.current_page;
            }
        };

        vm.pageChange = function () {
            vm.onPageChange && vm.onPageChange({$page: vm.currentPage});
        };
    },
    controllerAs: 'vm'
};

export default PaginationComponent;